import { Component, OnInit, Output, EventEmitter, Input, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Popover, PopoverModule } from 'primeng/popover';
import { PlannerService, List, Avatar } from '../../../core/services/planner.service';
import { DATA_STATE } from '../../../core/constants/data-state';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-planner-lists',
  standalone: true,
  imports: [CommonModule, FormsModule, PopoverModule, TranslocoPipe],
  templateUrl: './planner-lists.component.html',
  styleUrls: ['./planner-lists.component.scss'],
})
export class PlannerListsComponent implements OnInit {
  selectedWorkspace: any = null;

  newList: Partial<List> = {
    title: '',
    type: 'personal',
    avatar: {
      uuid: '',
      name: '',
      resource: '',
    },
  };

  listTypes = [
    {
      type: 'personal',
      labelKey: 'planner.listForm.personalTasks',
      icon: '🚀',
      iconClass: 'pi pi-user',
    },
    { type: 'team', labelKey: 'planner.listForm.teamTasks', icon: '👥', iconClass: 'pi pi-users' },
    {
      type: 'ticket',
      labelKey: 'planner.listForm.supportTickets',
      icon: '🎫',
      iconClass: 'fa-light fa-ticket-alt',
    },
  ];

  availableAvatars: Avatar[] = [];
  selectedAvatar: Avatar | null = null;

  constructor(
    private plannerService: PlannerService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.selectedWorkspace = this.config.data?.selectedWorkspace;
  }

  ngOnInit() {
    this.availableAvatars = DATA_STATE.FAKE_DATA.avatars.map((avatar) => ({
      uuid: avatar.uuid,
      name: avatar.name,
      resource: avatar.emoji,
    }));
    // Set default avatar
    this.selectedAvatar = this.availableAvatars[0];
    this.newList.avatar = this.selectedAvatar;
  }

  selectListType(type: string): void {
    if (type !== 'personal' && type !== 'team' && type !== 'ticket') {
      return;
    }
    this.newList.type = type;
    const listType = this.listTypes.find((lt) => lt.type === type);
    if (listType) {
      this.newList.avatar = {
        uuid: Date.now().toString(),
        name: listType.labelKey,
        resource: listType.icon,
      };
    }
  }

  selectAvatar(avatar: Avatar, avatarPopover: Popover): void {
    this.selectedAvatar = avatar;
    this.newList.avatar = avatar;
    avatarPopover.hide();
  }

  handleSubmit(): void {
    if (this.newList.title && this.newList.title.trim() && this.newList.avatar) {
      const listData = {
        title: this.newList.title.trim(),
        type: this.newList.type!,
        avatar: this.newList.avatar,
      };

      this.ref.close(listData);
    }
  }

  resetForm(): void {
    this.newList = {
      title: '',
      type: 'personal',
      avatar: {
        uuid: '',
        name: '',
        resource: '',
      },
    };
    this.selectedAvatar = this.availableAvatars[0];
  }

  closeForm(): void {
    this.ref.close();
  }

  onKeyPress(event: KeyboardEvent, action: () => void): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      action();
    }
  }
}
